import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import twoFaImage from "../assets/images/twoFA.png";

const Disable2Fa = ({ setPageNo, setTwoFaType }) => {
  function handleDisable() {
    setTwoFaType("deactivate");
    setPageNo(4);
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          className="relative w-30 h-10 rounded-full bg-transparent  border border-gray-100 border-opacity-35 text-text-secondary  flex justify-between px-4"
        >
          <span className="text-sm font-semibold">Deactivate 2FA</span>
          <ArrowRight className="w-4 h-4 text-gray-500 " />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md p-6 rounded-lg shadow-lg">
        <DialogHeader></DialogHeader>
        <div className="mb-3 flex justify-center">
          <img src={twoFaImage} alt="" />
        </div>
        <div className="mb-3 text-center">
          <p className="text-[24px] text-brand-primary font-semibold">
            Disable 2-Factor Authentication
          </p>
        </div>
        <div className="mb-5 text-center">
          <p className="font-normal text-text-secondary text-[16px] ">
            80eight requires 2-Factor Authentication in order to keep your
            account secure. We’d advise that you keep it enabled.
          </p>
        </div>
        <div className="flex justify-between">
          <div>
            <DialogClose className="w-full">
              <Button className="text-text-secondary font-semibold text-[14px] rounded-full bg-transparent border-[1px] hover:opacity-90 py-5 px-9">
                Cancel
              </Button>
            </DialogClose>
          </div>
          <div>
            <Button
              className="text-sm font-semibold text-white rounded-full bg-gradient-to-r from-purple-500 to-rose-600 hover:opacity-90 px-4 py-5"
              onClick={() => handleDisable()}
            >
              Disable 2-Factor Authentication
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Disable2Fa;
